import { GuidEmpty } from 'mbs-ui-kit';
import { Storages } from 'wizards/models/base/base-models/plan-storages-model';
import { NotificationsStepValue } from 'wizards/models/notifications-models';
import { PlanNameStepValue } from 'wizards/models/plan-name-models';
import { PrePostActionsStepValue } from 'wizards/models/pre-post-actions-models';
import { WhereBackupStepValue } from 'wizards/models/where-backup-models';

export class BaseFormModels {
  planNameStep: PlanNameStepValue = { Name: '', SavePlanInCloud: true, valid: true };
  whereBackupStep: WhereBackupStepValue = { IsHybridBackup: false, HybridID: GuidEmpty, ConnectionID: GuidEmpty, valid: false };
  Storages: Storages = { CloudStorages: [], LocalStorages: [] };

  prePostActionsStep: PrePostActionsStepValue = {
    executeCommandBeforeBackup: false,
    preAction: '',
    exitOnPreActionFail: true,
    executeCommandAfterBackupCompletion: false,
    postAction: '',
    executePostActionOnSuccess: true,
    valid: true
  };
  notificationStep: NotificationsStepValue = {
    receiveNotificationOnCompleteGroup: { flag: true, case: 'whenFails' },
    valid: true
  };

  constructor(
    public isNBF = false,
    public isUnix = false
  ) {}
}
